var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17 12.63l3 1.74M3.342 7L12 12m0 0l8.658-4.999M12 12v10m4.33-12.5L7.54 4.27m13.386 11.729V8c0-.715-.381-1.375-1-1.732L13 2.27a2.001 2.001 0 00-2 0L4.074 6.269a2 2 0 00-1 1.732v7.997c0 .715.381 1.375 1 1.732l6.926 4a2.001 2.001 0 002 0l6.926-4a2 2 0 001-1.731z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgOrders;